<!-- @veltra/icons generated sha256:8db69dd3895d5358 gen:8 source:src/svg/normal/left.svg -->
<script setup lang="ts">
defineOptions({ name: 'Left' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m3.914 8.5 3.297 3.297a.5.5 0 0 1-.015.713.487.487 0 0 1-.695-.01L2.217 8.216a.31.31 0 0 1 0-.433L6.5 3.499a.487.487 0 0 1 .695-.01l.008.008c.196.195.203.51.007.705L3.914 7.5h9.584a.49.49 0 0 1 .502.485v.011a.505.505 0 0 1-.502.504z"
    />
  </svg>
</template>
